import React from 'react';
import { Instagram, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-white/5 pt-16 pb-8" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 md:gap-0" data-id="element-110">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/2t1zJp6PAikQXJQD9A85yD/Logo.png" alt="Luciano Barber Shop Logo" className="h-20 w-auto object-contain mb-4 opacity-80 hover:opacity-100 transition-opacity" data-id="element-112" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-113">
              Luciano Barber <span className="text-gold" data-id="element-114">/</span> Academia
            </h3>
            <p className="text-gray-500 text-sm max-w-xs" data-id="element-115">
              Estética masculina y formación profesional de primer nivel.
            </p>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-116">
            <a href="https://instagram.com/lucianobarber_shop" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors group" data-id="element-117">
              <span className="text-sm font-medium" data-id="element-118">@lucianobarber_shop</span>
              <div className="bg-dark-lighter p-2 rounded-full group-hover:bg-gold/10 transition-colors" data-id="element-119">
                <Instagram size={18} data-id="element-120" />
              </div>
            </a>

            <div className="flex items-center gap-3 text-gray-400" data-id="element-121">
              <span className="text-sm font-medium" data-id="element-122">
                Av. Artigas 530, Las Piedras
              </span>
              <div className="bg-dark-lighter p-2 rounded-full" data-id="element-123">
                <MapPin size={18} data-id="element-124" />
              </div>
            </div>

            <a href="https://wa.me/59893472053" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors group" data-id="element-125">
              <span className="text-sm font-medium" data-id="element-126">093 472 053</span>
              <div className="bg-dark-lighter p-2 rounded-full group-hover:bg-gold/10 transition-colors" data-id="element-127">
                <Phone size={18} data-id="element-128" />
              </div>
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-129">
          <p className="text-gray-600 text-xs" data-id="element-130">
            © {new Date().getFullYear()} Luciano Barber Shop. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-131">
            <a href="#servicios" className="text-gray-600 hover:text-gray-300 text-xs transition-colors" data-id="element-132">
              Servicios
            </a>
            <a href="#academia" className="text-gray-600 hover:text-gray-300 text-xs transition-colors" data-id="element-133">
              Academia
            </a>
            <a href="#ubicacion" className="text-gray-600 hover:text-gray-300 text-xs transition-colors" data-id="element-134">
              Ubicación
            </a>
          </div>
        </div>
      </div>
    </footer>;
}